import { render, staticRenderFns } from "./cargoJC.vue?vue&type=template&id=1b771388&scoped=true&"
import script from "./cargoJC.vue?vue&type=script&lang=js&"
export * from "./cargoJC.vue?vue&type=script&lang=js&"
import style0 from "./cargoJC.vue?vue&type=style&index=0&id=1b771388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b771388",
  null
  
)

export default component.exports